module.exports = __webpack_public_path__ + "img/Pic_Banner-2.7d76b4f1.jpg";